export const nativeWebviewDebugger = (message, data = {}) => {
  const payload = {
    type: 'NATIVE_WEBVIEW_DEBUG',
    payload: {
      message,
      data
    }
  }

  if (window.ReactNativeWebView) {
    console.log('nativeWebviewDebugger (React Native)')
    window.ReactNativeWebView.postMessage(JSON.stringify(payload))
  } else if (window.webkit) {
    console.log('nativeWebviewDebugger (WebKit)')
    window.webkit.messageHandlers.nativeWebviewDebugger.postMessage(payload)
  } else if (window.JSInterface) {
    console.log('nativeWebviewDebugger (Android)')
    window.JSInterface.postMessage(JSON.stringify(payload))
  } else {
    console.log('nativeWebviewDebugger (DOM fallback)', payload)
  }
}

export default function(ctx, inject) {
  inject('nativeWebviewDebugger', nativeWebviewDebugger)
  ctx.$nativeWebviewDebugger = nativeWebviewDebugger
}
